/* eslint-disable react/require-default-props */
import { Box, Typography } from '@mui/material';
import { useRef } from 'react';

import { AssociationWOData } from '../../api/registryAssociation/types';
import {
  IconCloseMS,
  IconKeyboardArrowLeftMS,
  IconKeyboardArrowRightMS,
} from '../../constants/icons';
import { Constants } from './constants';
import {
  CloseButtonBox,
  CloseIcon,
  DialogContainer,
  AssociateButton,
  SpaceAroundBox,
  StyledDialog,
  StyledTypography,
  Title,
  OutlinedButton,
  ScrollableBox,
  ArrowButton,
  CarouselContainer,
} from './styles';
import WorkOrderItem from './WorkOderItem';

interface AssociateWorkOrderDialogProps {
  workOrders: AssociationWOData[];
  registerNumber: string;
  open: boolean;
  handleClose: () => void;
  shouldAssociate?: boolean | null;
  handleAssociate?: (value: boolean | null) => void;
  isEntrance?: boolean;
  callback?: () => Promise<void>;
}

export function AssociateWorkOrderDialog({
  workOrders,
  registerNumber,
  open,
  handleClose,
  shouldAssociate,
  handleAssociate,
  isEntrance = false,
  callback,
}: AssociateWorkOrderDialogProps): JSX.Element {
  const showCarousel = workOrders.length > 2;
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right'): void => {
    if (!scrollRef.current) return;

    const scrollAmount = 300;

    scrollRef.current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  let associateButtonProps = {};
  let associateOnClick;
  if (isEntrance) {
    if (shouldAssociate !== null) {
      associateButtonProps = { type: 'button' };
      associateOnClick = () => {
        handleClose();
        const form = document.getElementById('entrance') as HTMLFormElement;
        form?.requestSubmit();
        if (callback) callback();
      };
    } else if (handleAssociate) {
      associateButtonProps = { type: 'button' };
      associateOnClick = () => handleAssociate(true);
    }
  } else {
    associateOnClick = callback;
  }

  const associateButton = (
    <AssociateButton {...associateButtonProps} onClick={associateOnClick}>
      {shouldAssociate !== null && isEntrance
        ? Constants.approve
        : Constants.associate}
    </AssociateButton>
  );

  let onClick;
  if (isEntrance && handleAssociate) {
    onClick = () => handleAssociate(false);
  } else {
    onClick = handleClose;
  }

  const dontAssociateButton = (
    <OutlinedButton onClick={onClick}>{Constants.dontAssociate}</OutlinedButton>
  );
  return (
    <StyledDialog open={open} onClose={handleClose}>
      <CloseButtonBox>
        <CloseIcon onClick={handleClose}>{IconCloseMS}</CloseIcon>
      </CloseButtonBox>
      <DialogContainer>
        <Title>{Constants.associateWorkOrder}</Title>
        <StyledTypography>
          {Constants.registry} <span>{registerNumber || ''}</span>
        </StyledTypography>
        <Typography>{Constants.foundWorkOrders}</Typography>
        {showCarousel ? (
          <CarouselContainer>
            <ArrowButton disableTouchRipple onClick={() => scroll('left')}>
              {IconKeyboardArrowLeftMS}
            </ArrowButton>

            <ScrollableBox ref={scrollRef}>
              {workOrders.map((wo) => (
                <Box key={wo.id} minWidth={450}>
                  <WorkOrderItem workOrderData={wo} />
                </Box>
              ))}
            </ScrollableBox>

            <ArrowButton disableTouchRipple onClick={() => scroll('right')}>
              {IconKeyboardArrowRightMS}
            </ArrowButton>
          </CarouselContainer>
        ) : (
          workOrders.map((wo) => (
            <WorkOrderItem key={wo.id} workOrderData={wo} />
          ))
        )}
        <SpaceAroundBox>
          {shouldAssociate !== null && isEntrance ? (
            <Box sx={{ minWidth: 305 }} />
          ) : (
            dontAssociateButton
          )}
          {associateButton}
        </SpaceAroundBox>
      </DialogContainer>
    </StyledDialog>
  );
}
